import type {StackProps} from '@tempo/core';
import {Alert, AlertIcon, VStack, tempo, useToast} from '@tempo/core';
import {Form as FormikForm} from 'formik';
import {useEffect} from 'react';

export const Form: React.FC<
	React.PropsWithChildren<StackProps & {error?: string; withToast?: boolean}>
> = ({children, error, maxW = '512px', withToast = false, ...props}) => {
	const toast = useToast({id: 'form-component', duration: 2500});

	useEffect(() => {
		if (withToast && error) {
			toast({
				status: 'error',
				description: error,
			});
		}
	}, [error, withToast]);

	return (
		<FormikForm style={{width: '100%'}}>
			<VStack
				maxW={maxW}
				mx="auto"
				spacing="spacing.l"
				width="100%"
				data-formtype="multi-step"
				{...props}
			>
				{children}
				{error && !withToast && (
					<Alert status="error">
						<AlertIcon />
						{error}
					</Alert>
				)}
			</VStack>
		</FormikForm>
	);
};

/**
 * @deprecated Use Form instead
 */
const BaseFormElement = tempo(VStack);
export const FormElement = (props: Record<string, any>) => (
	<BaseFormElement as="form" width="100%" {...props} />
);
